<script>
import ActionTemplates from './ActionTemplates'
import ActionTemplateForm from './ActionTemplateForm'
import Truncate from 'vue-truncate-collapsed'

import SearchableList from './SearchableList'
import SearchBar from './SearchBar'
import BlankSlate from './BlankSlate'

export default {
  mixins: [SearchableList],

  components: {
    ActionTemplateForm,
    Truncate,
    SearchBar,
    BlankSlate
  },

  data() {
    return {
      showForm: false,
      actionTemplate: null,

      records: []
    }
  },

  methods: {
    createActionTemplate() {
      this.actionTemplate = ActionTemplates.default()
      this.showForm = true
    },

    reload() {
      this.showForm = false
      this.records = ActionTemplates.storage.all()
    },

    destroy(actionTemplate) {
      if (!confirm('Really?')) { return }
      actionTemplate.destroy()
      this.reload()
    },

    edit(actionTemplate) {
      this.actionTemplate = actionTemplate
      this.showForm = true
    },
  },

  watch: {
    showForm() {
      if (!this.showForm) {
        this.actionTemplate = null
      }
    }
  },

  mounted() {
    this.reload()
  }

}
</script>

<template>
  <div>
    <b-modal :active.sync="showForm" scroll="keep">
      <action-template-form :actionTemplate="actionTemplate" @save="reload" @cancel="showForm = false"></action-template-form>
    </b-modal>

    <search-bar>
      <b-button icon-left="plus" @click="createActionTemplate">Create new Action Template</b-button>
    </search-bar>


    <b-table :data="filteredRecords" :hoverable="true" detailed>
      <template slot-scope="props">
        <b-table-column field="name" label="Name">
          <p style="max-width:250px">
            {{ props.row.name }}
          </p>
        </b-table-column>
        <b-table-column field="requires" label="Requires">
          <ul class="is-size-7">
            <li v-for="key in props.row.pathParams">
              {{ key }}
            </li>
            <li v-for="(value, key) in props.row.input">
              {{ key }}
            </li>
          </ul>
        </b-table-column>
        <b-table-column field="provides" label="Provides">
          <ul class="is-size-7">
            <li v-for="(value, key) in props.row.output">
              {{ key }}
            </li>
          </ul>
        </b-table-column>

        <b-table-column>
          <b-loading :active="props.row.isLoading"></b-loading>
          <div class="buttons is-right">
            <b-button icon-left="square-edit-outline" size="is-small" @click="edit(props.row)">
            </b-button>
            <b-button icon-left="trash-can-outline" size="is-small" type="is-danger" @click="destroy(props.row)">
            </b-button>
          </div>
        </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <b-field horizontal label="Default Params">
          <pre class="is-size-7">{{ props.row.defaults }}</pre>
        </b-field>
      </template>

      <template slot="empty">
        <blank-slate @reload="reload" :isFiltered="!!searchQuery"></blank-slate>
      </template>

    </b-table>

  </div>
</template>

<style lang="scss" scoped>
table .buttons {
  opacity: 0.7;
}
table tr:hover .buttons {
  opacity: 1;
}
</style>